import { RoleContextProvider } from 'hybridspace-common/lib/context';
import usePlacesRouteLayout from '../usePlacesRouteLayout';
import HybridspaceNavHeader from './HybridspaceNavHeader';
import type { JSX } from 'react';

export function PlacesAppHeaderWithRole(): JSX.Element {
    // Request from MetaOs will have query strings: &ep=metaOS and &hostApp=xxxx (Teams, Monarch, etc)
    const { showCompactAppHeader } = usePlacesRouteLayout();
    return (
        <RoleContextProvider>
            <HybridspaceNavHeader showCompactAppHeader={showCompactAppHeader} />
        </RoleContextProvider>
    );
}
